document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector(
    '.js-kros-sub-header',
  ) as HTMLElement | null;

  function updateHeaderOffset() {
    if (!header) return;
    const offset = header.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-offset',
      `${offset}px`,
    );
  }

  // Nastavíme offset hneď pri načítaní
  updateHeaderOffset();

  // Dynamicky aktualizujeme pri resize
  window.addEventListener('resize', updateHeaderOffset);

  // Scroll manuálne pre rovnaký hash (napr. klik na button)
  function scrollToHash(hash: string) {
    const target = document.querySelector(hash);
    if (!target) return;

    const offset = header ? header.offsetHeight : 80;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const scrollPosition = targetPosition - offset;

    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth',
    });
  }

  // Scroll pri načítaní stránky s hashom
  if (location.hash && location.hash !== '#') {
    scrollToHash(location.hash);
  }

  // Scroll pri kliknutí na anchor linky alebo buttony
  document
    .querySelectorAll('a[href^="#"]:not([href="#"])')
    .forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const href = (e.currentTarget as HTMLAnchorElement).getAttribute(
          'href',
        );
        if (!href) return;

        if (location.hash === href) {
          history.replaceState(null, '', '#'); // resetujeme hash
        }

        // Scroll s offsetom
        scrollToHash(href);

        // Aktualizujeme hash v URL
        if (location.hash !== href) {
          history.pushState(null, '', href);
        }
      });
    });
});
